var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('img',{staticClass:"home-bg",attrs:{"src":'https://image-hast.huian365.com/prd/2024-03-13/huian/1710293346946.jpg?' +
      new Date().getTime(),"alt":""}}),_c('div',{staticClass:"button",on:{"click":_vm.goJobList}},[_vm._v("开始投递")])])
}
var staticRenderFns = []

export { render, staticRenderFns }